import React, { useEffect, useState } from 'react'
import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
} from '@mui/material'
import Button from '@mui/material/Button'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import SaveIcon from '@mui/icons-material/Save'
import ClearIcon from '@mui/icons-material/Clear'

import CircularLoading from '../../../../../components/CircularProgress'
import useAxios, { axiosInstance } from '../../../../../hooks/useAxios'
import { PaginationResponseInterface } from '../../../../../types/pagination'
import SelectSearch, {
  IOptionSelect,
} from '../../../../../components/SelectSearch'
import { IPipeline, IPipelineItem } from '../../../../../types/pipeline'
import { message } from 'antd'
import { ERRORS_MESSAGE_MAPPER } from '../../../../../constants/errors'
import PipelineSelectSearch from '../../../../../components/SelectSearch/PipelineSelectSearch'

interface IMoveLeadFormModalProps {
  isOpen: boolean
  objectIds: string[]
  onClose: (visible: boolean) => void
  onUpdateLeadListSuccess: () => void
}

interface IMoveLeadFormModal {
  pipelineObjectId: string
  activePipelineItemObjectId: string
  objectIds: string[]
}

const getMoveLeadFormValidationSchema = () => {
  return Yup.object({
    pipelineObjectId: Yup.string().required('กรุณาเลือก pipeline'),
    activePipelineItemObjectId: Yup.string().required(
      'กรุณาเลือกสถานะ Pipeline',
    ),
    objectIds: Yup.array().of(Yup.string()).required('กรุณาเลือก Lead'),
  })
}

export const MoveLeadFormModal = (props: IMoveLeadFormModalProps) => {
  const { isOpen, onClose, onUpdateLeadListSuccess } = props
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [searchPipeline, setSearchPipeline] = useState<string>('')
  const [pipeline, setPipeline] = useState<IPipeline>()
  useEffect(() => {
    setIsLoading(true)
    formik.setFieldValue('objectIds', props.objectIds)
    setIsLoading(false)
  }, [props.objectIds])

  const formik = useFormik<IMoveLeadFormModal>({
    initialValues: {
      pipelineObjectId: '',
      activePipelineItemObjectId: '',
      objectIds: [],
    } as IMoveLeadFormModal,
    validationSchema: getMoveLeadFormValidationSchema(),
    onSubmit: async (values: IMoveLeadFormModal) => {
      setIsLoading(true)
      try {
        await axiosInstance.put(`/lead/change-pipelines`, {
          ...values,
          pipelineName: pipeline?.name,
        })
        onUpdateLeadListSuccess()
        message.success('ย้าย Pipeline สำเร็จ')
        formik.resetForm()
        onClose(false)
      } catch (e: any) {
        const messageError =
          ERRORS_MESSAGE_MAPPER?.[e.response?.data?.message ?? ''] ||
          'บันทึกข้อมูลไม่สำเร็จ'
        message.error(messageError)
      }
      setIsLoading(false)
    },
  })

  const pipelineList = useAxios<PaginationResponseInterface<IPipeline>>({
    method: 'GET',
    url: '/pipeline',
    params: {
      page: 1,
      perPage: 5,
      search: searchPipeline,
      startDate: '',
      endDate: '',
    },
  })

  const handleSearchPipeline = async (value: string) => {
    setSearchPipeline(value)
    await pipelineList.mutate()
  }

  return (
    <Dialog open={isOpen} onClose={() => onClose(false)} maxWidth="lg">
      <CircularLoading isLoading={isLoading} />
      <DialogTitle>ย้าย Pipeline</DialogTitle>
      <DialogContent>
        <Box component="form" mt={1} onSubmit={formik.handleSubmit}>
          <Grid container spacing={2} justifyContent="space-between">
            <Grid item xs={12} lg={12}>
              {/* <SelectSearch<IPipeline>
                label={'เลือก pipeline'}
                onSelect={(e) => {
                  formik.setFieldValue('pipelineObjectId', e?.value.objectId)
                  setPipeline(e?.value)
                }}
                name="pipelineObjectId"
                helperText={
                  formik.touched.pipelineObjectId &&
                  (formik.errors.pipelineObjectId as string)
                }
                error={
                  !!(
                    formik.touched.pipelineObjectId &&
                    formik.errors.pipelineObjectId
                  )
                }
                onBlur={formik.handleBlur}
                search={searchPipeline}
                onSearch={handleSearchPipeline}
                options={
                  pipelineList.data?.records.map((pipeline: IPipeline) => ({
                    label: pipeline.name,
                    value: pipeline,
                  })) || ([] as IOptionSelect<IPipeline>[])
                }
              /> */}

              <PipelineSelectSearch
                multiple={false}
                onSelect={(e) => {
                  formik.setFieldValue('pipelineObjectId', e?.value.objectId)
                  setPipeline(e?.value)
                }}
                name="pipelineObjectId"
                helperText={
                  formik.touched.pipelineObjectId &&
                  (formik.errors.pipelineObjectId as string)
                }
                error={
                  !!(
                    formik.touched.pipelineObjectId &&
                    formik.errors.pipelineObjectId
                  )
                }
                onBlur={formik.handleBlur}
              />
            </Grid>
            {!!formik.values.pipelineObjectId && (
              <Grid item xs={12} lg={12}>
                <FormControl variant="filled" fullWidth>
                  <InputLabel id="selectStepper-label">
                    เลือกสถานะ Pipeline
                  </InputLabel>
                  <Select
                    id="selectStepper"
                    name="selectStepper"
                    labelId="selectStepper-label"
                    value={formik.values.activePipelineItemObjectId}
                    onChange={(e) =>
                      formik.setFieldValue(
                        'activePipelineItemObjectId',
                        e.target.value as string,
                      )
                    }
                    fullWidth
                  >
                    <MenuItem value="" selected>
                      <em>เลือกสถานะ</em>
                    </MenuItem>
                    {pipeline?.items.map(
                      (item: IPipelineItem, index: number) => (
                        <MenuItem value={item.objectId} key={index}>
                          {item.name}
                        </MenuItem>
                      ),
                    )}
                  </Select>
                </FormControl>
              </Grid>
            )}
          </Grid>
          <Grid container spacing={2} mt={2} justifyContent={'flex-end'}>
            <Grid item>
              <Button
                startIcon={<SaveIcon />}
                color="primary"
                type="submit"
                size="large"
                variant="contained"
              >
                บันทึก
              </Button>
            </Grid>
            <Grid item>
              <Button
                color="inherit"
                size="large"
                variant="contained"
                onClick={() => onClose(false)}
                startIcon={<ClearIcon />}
              >
                ปิดหน้าต่าง
              </Button>
            </Grid>
          </Grid>
        </Box>
      </DialogContent>
    </Dialog>
  )
}
